type Props = { className?: string };

export function Wordmark({ className = "text-xl" }: Props) {
  return (
    <span
      className={`inline-flex items-center gap-2 font-display font-extrabold tracking-tight ${className}`}
    >
      <span
        aria-hidden="true"
        className="inline-block h-2 w-2 rounded-full bg-success dark:bg-primary"
      />
      <span className="inline-flex">
        <span className="text-foreground">Coach</span>
        <span className="text-success dark:text-primary">Quick</span>
      </span>
    </span>
  );
}
